import { isPossiblePhoneNumber } from 'libphonenumber-js'

import { COUNTRY_CODE } from './format-phone-number'

export function validatePhoneNumber(value: string): string | undefined {
  if (!value) return undefined

  if (!isPossiblePhoneNumber(value, COUNTRY_CODE)) {
    return 'Invalid phone number'
  }

  return undefined
}
